import React from 'react';
import StockItemsPage from 'pages/shared/inventory-stock/stock-items-page';

const BrandChefStock = () => {
  return <StockItemsPage defaultStoreType='brand-chef-store' />;
};

export default BrandChefStock;
